"use client";

import { useTranslations } from "@/i18n";

import { GoogleIcon } from "@/components";
import { isGoogleOAuthConfigured } from "@/constants";

import { useGoogleSignInButton } from "./_hooks/useGoogleSignInButton";

import styles from "./GoogleSignInButton.module.scss";

/**
 * Active Google button — only mounted when OAuth client ID is configured
 * (useGoogleLogin requires GoogleOAuthProvider).
 */
const GoogleSignInButtonActive = () => {
  const t = useTranslations("login.googleAuth");
  const { loading, handleFormSubmit } = useGoogleSignInButton();

  return (
    <div className={styles["comp"]} onClick={handleFormSubmit}>
      {!loading && (
        <div className={styles["comp__content"]}>
          <GoogleIcon />
          <div className={styles["comp__label"]}>{t("continueWithGoogle")}</div>
        </div>
      )}

      {loading && (
        <div className={styles["comp__content"]}>
          <div className={styles["comp__loading"]} />
          <div className={styles["comp__label"]}>{t("loggingInProgress")}</div>
        </div>
      )}
    </div>
  );
};

/**
 * GoogleSignInButton — rendered only when NEXT_PUBLIC_GOOGLE_CLIENT_ID is set.
 * When unset, returns null so email/password auth remains usable.
 */
export const GoogleSignInButton = () => {
  if (!isGoogleOAuthConfigured()) {
    return null;
  }

  return <GoogleSignInButtonActive />;
};
